export const LogoMark = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="gm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#9B7BFF" />
        <stop offset="1" stopColor="#6D3CF0" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="16" fill="url(#gm)" />
    <path d="M19 20l13 28 13-28" fill="none" stroke="#fff" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="49" cy="15" r="4" fill="#fff" />
  </svg>
);

export const Logo = () => (
  <div className="flex items-center gap-3" data-testid="store-logo">
    <LogoMark />
    <span className="font-display text-xl font-semibold tracking-tight text-white">VAULT GIFT</span>
  </div>
);
